import { apiClient } from '../core/client';

export const fetchPartnerLogSuggestions = async ({ association_type, search }) => {
  const res = await apiClient(
    `${process.env.REACT_APP_API_URL}telemetry_dashboard_data/log-partners/?association_type=${association_type}&search=${search}`
  );

  return res.json();
};
